import { Link } from "react-router-dom";

// Urls
import { RedirectTo } from "../../urls/PageLinksURL";

// Constants and Utils
import { checkIsSellerUser } from "../../utils/SellerUtils";
import { constructRedirectPath } from "../../utils/redirect-utils/RedirectUtils";
import {
  LocalStorageKeys,
  OrganizationIdsMapping,
} from "../../constants/GeneralConstants";
import { getItem } from "../../utils/localstorage";
import { checkIsOrgSpecific } from "../../utils/OrgUtils";

// Page Constants
const {
  helpOtsPageUrl,
  helpLtsPageUrl,
  helpCovidChangePageUrl,
  helpDefinitionPageUrl,
  helpVideosPageUrl,
} = RedirectTo;

/**
 * Help Sidebar
 */
export default function HelpSidebar({ activePageUrl = "" }) {
  // Checking the USER is Seller or not
  const isSellerUser = checkIsSellerUser();

  // coral media
  const user = JSON.parse(getItem(LocalStorageKeys.USER));
  const { orgId } = user || {};
  const { coralMedia } = OrganizationIdsMapping;
  const isCoralMediaSpecific = checkIsOrgSpecific(orgId, coralMedia);

  // constants
  const sidebarGeneralConstants = [
    {
      label: "Definitions",
      pageUrl: helpDefinitionPageUrl,
    },
    {
      label: "Videos",
      pageUrl: helpVideosPageUrl,
    },
  ];

  const sidebarMethodologiesConstants = [
    {
      label: "OTS",
      pageUrl: helpOtsPageUrl,
      isShow: true,
    },
    {
      label: "LTS",
      pageUrl: helpLtsPageUrl,
      isShow: true,
    },
    {
      label: "Covid % Change",
      pageUrl: helpCovidChangePageUrl,
      isShow: isCoralMediaSpecific ? false : true, // hiding for coralMediaOrg
    },
  ];

  return (
    <aside className="sidebar bg-alt">
      <ul className="nav flex-column mt-3">
        <li className="nav-item group-header">General</li>
        {sidebarGeneralConstants.map((info, i) => {
          const { pageUrl, label } = info;
          const activeClassName = activePageUrl === pageUrl && "active";

          return (
            <li key={i} className={`nav-item ${activeClassName}`}>
              <Link className="nav-link" to={constructRedirectPath(pageUrl)}>
                {label}
              </Link>
            </li>
          );
        })}

        {/* Hiding in case of "Seller-Login" */}
        {!isSellerUser && (
          <>
            <li className="nav-item group-header">Methodologies</li>
            {sidebarMethodologiesConstants.map((info, i) => {
              const { isShow = true, pageUrl, label } = info;
              const activeClassName = activePageUrl === pageUrl && "active";

              if (!isShow) {
                return null;
              }

              return (
                <li key={i} className={`nav-item ${activeClassName}`}>
                  <Link
                    className="nav-link"
                    to={constructRedirectPath(pageUrl)}
                  >
                    {label}
                  </Link>
                </li>
              );
            })}
          </>
        )}
      </ul>
    </aside>
  );
}
